import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import BaseFrame from 'templates/PageFrame';
import LogoutPageLayout from 'templates/LogoutLayout/LogoutLayout';
import PostStateToast from 'dataProvider/postStateData/components/PostStateToast';
import { useAuth } from 'dataProvider/authData';
import { useGlobalData } from 'dataProvider/globalData';
import useTransition from 'hooks/useTransition';
import { showOrUpdateToast } from 'utils/toastUtil';

export default function LogoutPage() {
    const { logout, auth } = useAuth();
    const [wasAuthenticated] = useState(auth.isAuthenticated);
    const { pushHistorySibling, getParentPath } = useTransition();
    const [{ screen }] = useGlobalData();
    const history = useHistory();

    useEffect(() => {
        if (wasAuthenticated) {
            logout();
        } else {
            pushHistorySibling('/login');
        }
    }, []);

    useEffect(() => {
        if (!wasAuthenticated || screen !== 'sp') return;

        showOrUpdateToast(null, <PostStateToast message="ログアウトが完了しました" />, {
            autoClose: 5000,
            closeButton: true,
        });
        history.replace(`${getParentPath()}/login`);
    }, [screen]);

    return (
        <BaseFrame title="Logout">
            <LogoutPageLayout />
        </BaseFrame>
    );
}
